<template>
    <div class="service-wrap pt-20 pb-20">
        <div class="container">
            <div class="row mb-5">
            <div class="col-12">
                <h3 class="mb-2">« PELERINAGE AUX SOURCES DE LA FOI »    édition 2024</h3>

                <p class="mb-2 texte">Le processus initiatique à l’Ecole d’Initiation Théologique et Pastorale (EITP) intègre le « pèlerinage aux sources de la foi », parcours de véritable ressourcement spirituel et théologique et de mémoire. Le dimanche 14 juillet 2024, 70 apprenants en ont vécu la 7ème édition à Ouidah, pour mieux comprendre le contexte dans lequel la rencontre de la foi avec des cultures complexes s’est opérée, s’imprégner des paysages dans lesquels le Seigneur a semé la Bonne nouvelle en Afrique et particulièrement au Bénin et s’engager dans une démarche de conversion pour oser défricher de nouveaux chantiers missionnaires.
De Ouidah, première ville ayant accueilli les missions venues au Dahomey en 1861, la mission s’est ébranlée dans tout le pays et même bien au- delà. Elle abrite des lieux chargés d’histoire et de foi comme la Porte de non-retour à la porte du Salut (toutes deux à la plage), le Fort portugais ; le Grand Séminaire Saint Gall (le calvaire, le cimetière des prêtres et la chapelle du séminaire) et la Basilique Immaculée Conception. 
A la porte de non-retour qui évoque l’esclavage, haut lieu de défiguration de l’humanité à laquelle nos peuples ont aussi activement collaboré, de manière consciente ou inconsciente, le Père Rodrigue GBEDJINOU, a invité les pèlerins à une conversion de vie, en leur  rappelant que « l’esclavage n’est pas que d’hier : il se vit encore en diverses formes d’esclavages modernes et même dans nos maisons et services, avec nos employés et les vidomègon, par nos silences complices face aux divers malheurs où tant de nos frères et sœurs sont acculés ». Il leur a recommandé, à cet instant, « Silence, recueillement, conversion et aussi confession d’amour de Dieu qui est la lumière dans nos ténèbres » et dont la lumière a lui sur nos côtes, comme le symbolise la Porte du Salut. 
La Porte du Salut évoque la rédemption et l'espérance offertes par la foi chrétienne, en contraste avec la Porte du Non-Retour. De celle-ci, à la porte du Salut, les pèlerins ont marché en silence. Face à la mer, ils ont relu le témoignage de l’arrivée des premiers missions et ont fait leur renonciation au mal, avant de franchir la porte dans la foi, en posant leur main sur la Bible. Face à la Croix, ils ont redit leur profession de foi, symbole d’engagement et d’une démarche vers une vie renouvelée en Christ. 
Pour ces pèlerins, ce parcours a été une lumière sur des points d’ombre relatifs à la mission de l’Eglise au Bénin. Des sources de la foi, ils sont repartis pour continuer l’œuvre entreprise par ces missionnaires, apportés la lumière du Christ dans les ténèbres, transformer les lieux de déshumanisation en lieu d’humanisation et de glorification. 
Au-delà des apprenants de l’EITP engagés dans un processus d’approfondissement de leur Foi, ce pèlerinage est nécessaire à tout chrétien catholique béninois. 
</p>
            <h6 class="mb-2"> Josephine KANAKIN,  la Revue de l’EITP.</h6>
            </div>
            </div>



            <div class="row ">
                <div class="col-xl-4 col-lg-6 col-md-6" v-for="(article, index) in truncatedArticles" :key="index">
                    <div class="blog-card style1">
                        <div class="blog-img"  :style="{height:'277px', backgroundImage: `url(${getUrlApiForFiles(article.urlImage)})`, backgroundSize: 'cover',backgroundPosition: 'center'}"
                        >
                        </div>
                        <div class="blog-info" style="min-height: 250px;">
                            <ul class="blog-metainfo  list-style">
                                <li><i class="flaticon-user"></i> <router-link to="#">L' École d’Initiation Théologique et Pastorale</router-link></li>
                                <li><i class="flaticon-calendar"></i>{{ format_Date(article.datePublication)  }}</li>
                            </ul>
                            <h3><router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }">{{ article.titre }}</router-link></h3>
                            <router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }" class="link style1">Lire plus
                                <i class="flaticon-right-arrow"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div> 
            <div class="">
                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import ApiService from "@/services/ApiService";
import { getUrlApiForFiles, error,format_Date } from "@/utils/utils";
import { defineComponent, ref, onMounted, computed } from "vue";
import { Article } from "@/models/Article";
import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
    name: 'ConferenceAvant',
    components: {
      PaginationComponent,

  },
  setup(){

    const articles = ref<Array<Article>>([]);   

        // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
   const recollections = ref([
  {
    date: '18 et 20 décembre 2025',
    theme: '« Et après le jubilé ? »',
    communicateur: 'Père Narcisse Bah-Kpêvi'
  },
  {
    date: '19 et 21 décembre 2024',
    theme: '« Pèlerins et témoins d’espérance »',
    communicateur: 'Père Albino Binazon'
  },
  {
    dates: '21 et 23 mars 2024',
    theme: '« Pour moi, vivre c’est le Christ » (Ph 1,21)',
    communicateur: 'Père Romuald Hounsa'
  },
  {
    date: '16 et 19 décembre 2023',
    theme: '« Je suis venu pour qu’ils aient la vie et la vie en abondance » (Jn 10,10)',
    communicateur: 'Père Nathanaël Dan'
  },
  {
    date: '17 et 20 décembre 2022',
    theme: '« Vous êtes le sel de la terre, la lumière du monde » (Mt 5,13-14)',
    communicateur: ''
  },
  {
    date: '07 et 09 avril 2022',
    theme: '« Comment être témoin du salut dans le monde de ce temps ? »',
    communicateur: 'Père Philippe Donou'
  },
  {
    date: '18 et 21 décembre 2021',
    theme: 'Le Seigneur vient : de quoi vient-il nous sauver ?',
    communicateur: 'Père Narcisse Bah-Kpêvi'
  },
  {
    date: '25 et 27 mars 2021',
    theme: 'Comment comprendre la semaine sainte, comment la vivre ?',
    communicateur: 'Père Saturnin Lawson'
  },
  {
    date: '19 et 22 décembre 2020',
    theme: 'Le Seigneur vient, prépare-toi à l’accueillir',
    communicateur: 'Père Guillaume Chogolou'
  },
  {
    date: '19 et 20 décembre 2019',
    theme: 'Temps de Noël : Quelle place l’Enfant-Dieu trouvera-t-il dans ton cœur ?',
    communicateur: 'Frère Maxime Janvier Djossa'
  },
  {
    dates: '20 au 22 septembre 2019',
    theme: '« Saisi par le Christ Jésus, je cours droit vers le but » (Ph 3,12-14)',
    communicateur: 'Père Ghislain Sanny'
  },
  {
    date: '11 et 12 avril 2019',
    theme: 'La croix : victoire de l’amour sur la haine',
    communicateur: 'Mgr Aristide Gonsallo, Père Jacques Gnonhossou, Père Didier Agondjihossou'
  },
  {
    date: '21 décembre 2018',
    theme: 'Le Verbe s’est fait chair, il a habité parmi nous',
    communicateur: 'Père Sobakin Raymond, Père Maxime Noudéhou, Père Crépin Magloire Acapovi'
  },
  {
    date: '22, 24 et 25 mars 2018',
    theme: 'La Pâque chrétienne et ses implications sociales',
    communicateur: 'Père Placide Augustin Houéssinon, Père Roger Sèvoh'
  }
]);



    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getTreeArticle(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher(){
        getTreeArticle(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getTreeArticle(page = 1, limi = 9, searchTerm = '') {
      return ApiService.get(`/actualite/articles/39?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      
      .then(({ data }) => {
        articles.value = data.data.data;
        console.log("fff",articles.value)
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    } 

    const truncatedArticles = computed(() => {
        const maxLength = 100; 
        return articles.value.map(article => {
            if (article.titre.length > maxLength) {
            return {
                ...article,
                titre: article.titre.substring(0, maxLength) + '...'
            };
            }
            return article;
        });
    });

    // function getTreeArticle() {
    //   return ApiService.get(`/actualite/articles/22`)
    //     .then(({ data }) => {
    //       articles.value = data.data.data;
    //       console.log(articles.value);
    //       return data.data;
    //     })
    //     .catch(({ response }) => {
    //       error(response.message)
    //   });
    // }
    
    onMounted(() => {
        getTreeArticle();
    });

    return { 
        recollections,
        articles,
        getUrlApiForFiles,
        format_Date,
        page, 
        totalPages,
        limit,
        totalElements,
        handlePaginate,
        truncatedArticles
    };
  },
});
</script>

<style scoped>
    .blog-card .blog-info h3 {
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 15px;
    }
    .texte{
        text-align: justify;
    }
</style>